import axios from "axios";
import { clearAuthToken, getAuthToken } from "../auth/tokenStorage";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api"
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAuthToken();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
